<template>
  <!--审核-->
  <div class="table-page-search-wrapper">
    <a-form :form="form" layout="inline">
      <a-row :gutter="6">
        <a-col :span="6">
          <a-form-item label="订单号" style="margin-left: 13px">
            <a-input v-decorator="['orderNo', { rules: [{ required: false, message: '请输入订单号' }] }]" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="企业名称">
            <a-input v-decorator="['enterpriseName', { rules: [{ required: false, message: '请输入订单号' }] }]" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="申请人" style="margin-left: 13px">
            <a-input v-decorator="['createByName', { rules: [{ required: false, message: '请输入订单号' }] }]" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="申请时间">
            <a-range-picker
              v-decorator="['datatime1']"
              :show-time="{
                hideDisabledOptions: true,
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
              }"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']"
              @change="onChange1"
              @ok="onOk"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="6">
        <a-col :span="6">
          <a-form-item label="审核类型">
            <a-select v-decorator="['matterCode', { rules: [{ required: false, message: '选择' }] }]">
              <a-select-option :title="type.name" v-for="type in resTypes" :key="type.code">{{
                type.name
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!--        <a-col :span="6">-->
        <!--          <a-form-item label="审核状态" style="margin-left: 13px;">-->
        <!--            <a-select v-decorator="['auditStatus', { rules: [{ required: false, message: '选择' }] }]" >-->
        <!--              <a-select-option  title="待审核" value="0">-->
        <!--                待审核-->
        <!--              </a-select-option>-->
        <!--              <a-select-option  title="通过" value="1">-->
        <!--                通过-->
        <!--              </a-select-option>-->
        <!--              <a-select-option title="不通过" value="2">-->
        <!--                不通过-->
        <!--              </a-select-option>-->
        <!--            </a-select>-->
        <!--          </a-form-item>-->
        <!--        </a-col>-->
        <!--<a-col :span="6">-->
        <!--<a-form-item label="审核人" style="margin-left: 13px;">-->
        <!--<a-input  v-decorator="['reviewerName', { rules: [{ required: false, message: '请输入订单号' }] }]"/>-->
        <!--</a-form-item>-->
        <!--</a-col>-->
        <!--<a-col :span="6">-->
        <!--<a-form-item label="审核时间">-->
        <!--<a-range-picker-->
        <!--v-decorator="['datatime2']"-->
        <!--:showTime="{ format: 'HH:mm:ss' }"-->
        <!--format="YYYY-MM-DD HH:mm:ss"-->
        <!--@change="onChange2"-->
        <!--@ok="onOk"-->
        <!--style="width: 100%"-->
        <!--/>-->
        <!--</a-form-item>-->
        <!--</a-col>-->

        <a-col :span="6">
          <a-form-item label="申请内容">
            <a-input v-decorator="['content', { rules: [{ required: false, message: '请输入订单号' }] }]" />
          </a-form-item>
        </a-col>
      </a-row>
      <!--      <a-row :gutter="6">-->
      <!--       -->
      <!--&lt;!&ndash;        <a-col :span="6">&ndash;&gt;-->
      <!--&lt;!&ndash;          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总处理时长">&ndash;&gt;-->
      <!--&lt;!&ndash;            <a-row>&ndash;&gt;-->
      <!--&lt;!&ndash;              <a-col :span="6">&ndash;&gt;-->
      <!--&lt;!&ndash;                <a-input v-model="querytime.textTime3"  @keyup.native="number3"/>&ndash;&gt;-->
      <!--&lt;!&ndash;              </a-col>&ndash;&gt;-->
      <!--&lt;!&ndash;              <a-col :span="2">&ndash;&gt;-->
      <!--&lt;!&ndash;                <span>至</span>&ndash;&gt;-->
      <!--&lt;!&ndash;              </a-col>&ndash;&gt;-->

      <!--&lt;!&ndash;              <a-col :span="6">&ndash;&gt;-->
      <!--&lt;!&ndash;                <a-input v-model="querytime.textTime4" @keyup.native="number4"/>&ndash;&gt;-->
      <!--&lt;!&ndash;              </a-col>&ndash;&gt;-->
      <!--&lt;!&ndash;              <a-col :span="10">&ndash;&gt;-->
      <!--&lt;!&ndash;                <a-select v-model="querytime.selectTime2"   @change="timeChange2">&ndash;&gt;-->
      <!--&lt;!&ndash;                  <a-select-option title="选择" value=""> 选择 </a-select-option>&ndash;&gt;-->
      <!--&lt;!&ndash;                  <a-select-option title="天" value="d"> 天 </a-select-option>&ndash;&gt;-->
      <!--&lt;!&ndash;                  <a-select-option title="小时" value="h"> 小时 </a-select-option>&ndash;&gt;-->
      <!--&lt;!&ndash;                </a-select>&ndash;&gt;-->
      <!--&lt;!&ndash;              </a-col>&ndash;&gt;-->
      <!--&lt;!&ndash;            </a-row>&ndash;&gt;-->
      <!--&lt;!&ndash;          </a-form-item>&ndash;&gt;-->
      <!--&lt;!&ndash;        </a-col>&ndash;&gt;-->
      <!--      </a-row>-->
      <a-row :gutter="6" style="margin: 20px 0 50px 0">
        <a-col :span="16">
          <!--            <a-radio-group name="radioGroup" v-model="isMyCreate" >-->
          <!--              <a-radio :value="'0'">-->
          <!--                我的待办-->
          <!--              </a-radio>-->
          <!--              <a-radio :value="'1'">-->
          <!--                我的发起-->
          <!--              </a-radio>-->
          <!--            </a-radio-group>-->
        </a-col>
        <a-col :span="4" :offset="3">
          <span style="display: flex; justify-content: center">
            <a-button class="twobtn" style="margin-left: 20px" type="primary" v-if="exportEnable" @click="exporto()"
              >导出</a-button
            >
            <a-button class="twobtn" style="margin-left: 35px" htmlType="submit" type="primary" @click="query()"
              >查询</a-button
            >
            <a-button class="twobtn" style="margin-left: 35px" @click="restdata()">清空</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form>
    <a-table
      size="default"
      ref="table"
      rowKey="modelId"
      :pagination="pagination"
      :loading="loading"
      :columns="columns"
      :data-source="complaintData"
      :scroll="{ x: 200 }"
      bordered
    >
      <span slot="action2" slot-scope="text, record">
        <a-popover title="订单子状态">
          <template slot="content">
            <div style="overflow-y: auto; max-height: 250px; padding-right: 20px">
              <p v-for="item in record.orderSubStatusList">{{ item }}</p>
            </div>
          </template>
          <a type="primary">
            {{ text }}
          </a>
        </a-popover>
      </span>
      <span slot="action" slot-scope="text, record">
        <a v-if="record.statusCode == 0" @click="handles(record)">审核 <a-divider type="vertical"/></a>

        <a v-if="record.statusCode == 0 && dispatchEnable" @click="Transfer(record)"
          >转派<a-divider type="vertical"
        /></a>

        <a-popover trigger="click" title="履历">
          <template slot="content">
            <div style="overflow-y: auto; max-height: 250px; padding-right: 20px">
              <div v-for="item in dataResume">
                <p>履历内容:{{ item.content }}</p>
                <p>操作人姓名:{{ item.createName }}</p>
                <p>操作时间:{{ item.createTime }}</p>
                <a-divider type="vertical" />
              </div>
            </div>
          </template>
          <a @click="Resume(record)" v-if="recodeEnable"> 履历 </a>
        </a-popover>
      </span>
    </a-table>
    <!--分页-->
    <a-pagination
      show-size-changer
      show-quick-jumper
      :default-current="1"
      :total="total"
      @change="onChangePage"
      @showSizeChange="onShowSizeChange"
      style="float: right; margin: 30px 10px 10px 0"
    />
    <!--转派弹框-->
    <a-modal
      title="转派"
      :width="800"
      v-model="visible2"
      :confirmLoading="confirmLoading2"
      @ok="handleSubmit2"
      :closable="false"
      :maskClosable="false"
    >
      <a-form :form="form2" layout="inline">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item label="转派角色">
              <a-select
                v-decorator="['roleCode', { rules: [{ required: false, message: '选择' }] }]"
                style="width: 300px"
              >
                <a-select-option v-for="type in Roledata" :key="type.code">{{ type.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--员工审核-->
    <a-modal
      title="员工审核"
      :width="800"
      v-model="visible3"
      :confirmLoading="confirmLoading3"
      @ok="handleSubmit3"
      @cancel="handleClose1"
      :closable="false"
      :maskClosable="false"
    >
      <div class="table-page-search-wrapper">
        <a-form :form="form3" layout="inline">
          <a-row :gutter="24">
            <!--<a-col :span="20" :offset="2">-->
            <a-col :span="12">
              <a-form-item label="用户名" style="width: 310px">
                <a-input
                  v-decorator="['loginName', { rules: [{ required: true, message: '请输入用户名' }] }]"
                  disabled="true"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="姓名" style="width: 310px">
                <a-input v-decorator="['userName', { rules: [{ required: true, message: '请输入姓名' }] }]" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="手机号" style="width: 310px">
                <a-input v-decorator="['phone', { rules: [{ required: true, message: '请输入手机号' }] }]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="备用联系方式" style="width: 310px">
                <a-input
                  v-decorator="['contactReserve', { rules: [{ required: true, message: '请输入备用联系方式' }] }]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="性别" style="width: 310px">
                <a-select
                  v-decorator="['sex', { rules: [{ required: false, message: '请输入性别' }] }]"
                  :allowClear="true"
                >
                  <a-select-option value="0"> 男 </a-select-option>
                  <a-select-option value="1"> 女 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="部门" style="width: 310px">
                <a-select
                  :allowClear="true"
                  :options="departmentData"
                  v-decorator="['deptId', { rules: [{ required: true, message: '请选择部门' }] }]"
                ></a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="角色" style="width: 310px">
                <!--mode="multiple"-->
                <a-select
                  :allowClear="true"
                  :options="roleData"
                  v-decorator="['roleIds', { rules: [{ required: true, message: '请选择角色' }] }]"
                ></a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="入职时间" style="width: 310px">
                <a-date-picker
                  v-decorator="['entryTime', { rules: [{ required: false, message: '请选择入职时间' }] }]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="紧急联系人" style="width: 310px">
                <a-input v-decorator="['emergencyContact', { rules: [{ required: false }] }]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="紧急联系人电话" style="width: 310px">
                <a-input v-decorator="['linkmanPhonenumber', { rules: [{ required: false }] }]" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item label="员工地址" style="width: 688px">
                <a-row :gutter="24">
                  <a-col :span="5">
                    <a-form-item>
                      <a-select
                        :allowClear="true"
                        :options="provinceMap"
                        @change="changeProvince"
                        v-decorator="['provinceId', { rules: [{ required: false, message: '请选择省' }] }]"
                      ></a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5">
                    <a-form-item>
                      <a-select
                        :allowClear="true"
                        :options="cityMap"
                        @change="changeCity"
                        v-decorator="['cityId', { rules: [{ required: false, message: '请选择市' }] }]"
                      ></a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5">
                    <a-form-item>
                      <a-select
                        :allowClear="true"
                        :options="areaArr"
                        v-decorator="['districtId', { rules: [{ required: false, message: '请选择区' }] }]"
                      ></a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="9">
                    <a-form-item>
                      <a-input
                        :allowClear="true"
                        v-decorator="['detailedAddress', { rules: [{ required: false, message: '请输入详细地址' }] }]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="审核状态" style="width: 310px">
                <a-select
                  v-decorator="['auditStatus', { rules: [{ required: true, message: '选择' }], initialValue: '1' }]"
                >
                  <a-select-option value="1"> 通过 </a-select-option>
                  <a-select-option value="2"> 不通过 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
    <!--企业审核-->
    <a-modal
      title="企业审核"
      style="top: 20px"
      :width="800"
      v-model="visible4"
      :confirmLoading="confirmLoading4"
      :maskClosable="false"
      @cancel="handleClose2"
      @ok="handleSubmit4"
    >
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form4">
          <!--<label>基本信息</label>-->
          <a-row>
            <a-col :span="12">
              <a-form-item label="企业名称" style="width: 310px">
                <a-input v-decorator="['enterpriseName', { rules: [{ required: true, message: '请输入企业名称' }] }]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="企业简称" style="width: 310px">
                <a-input
                  v-decorator="['enterpriseSysName', { rules: [{ required: true, message: '请输入企业简称' }] }]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="注册人" style="width: 310px">
                <a-input v-decorator="['register', { rules: [{ required: true, message: '请输入注册人' }] }]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="联系方式" style="width: 310px">
                <a-input v-decorator="['registerPhone', { rules: [{ required: true, message: '请输入联系方式' }] }]" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="企业账号" style="width: 310px">
                <a-input v-decorator="['loginName', { rules: [{ required: true, message: '请输入企业账号' }] }]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="账号姓名" style="width: 310px">
                <a-input v-decorator="['userName', { rules: [{ required: true, message: '请输入姓名' }] }]" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="手机号" style="width: 310px">
                <a-input v-decorator="['phone', { rules: [{ required: true, message: '请输入手机号' }] }]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="安装类别" style="width: 310px">
                <a-select
                  mode="multiple"
                  v-decorator="['installTypes', { rules: [{ required: true, message: '请选择安装类别' }] }]"
                >
                  <a-select-option v-for="item in installTypeMap" :key="item.code">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="默认安装类别" style="width: 310px">
                <a-select
                  v-decorator="['defaultInstallType', { rules: [{ required: true, message: '请选择默认安装类别' }] }]"
                >
                  <a-select-option v-for="item in installTypeMap" :key="item.code">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="角色" style="width: 310px">
                <a-select
                  :allowClear="true"
                  :options="roleData2"
                  v-decorator="['roleIds', { rules: [{ required: true, message: '请选择角色' }] }]"
                ></a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="审核状态" style="width: 310px">
                <a-select
                  v-decorator="['auditStatus', { rules: [{ required: true, message: '选择' }], initialValue: '1' }]"
                >
                  <a-select-option value="1"> 通过 </a-select-option>
                  <a-select-option value="2"> 不通过 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
    <!--师傅审核-->
    <a-modal
      title="师傅审核"
      style="top: 20px"
      :width="800"
      v-model="visible5"
      :confirmLoading="confirmLoading5"
      :maskClosable="false"
      @cancel="handleClose3"
      @ok="handleSubmit5"
    >
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form5">
          <!--<label>基本信息</label>-->
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="姓名" style="width: 320px">
                <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入姓名' }] }]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="性别" style="width: 320px">
                <a-select
                  v-decorator="['sex', { rules: [{ required: true, message: '请选择性别' }] }]"
                  :allowClear="true"
                >
                  <a-select-option value="0"> 男 </a-select-option>
                  <a-select-option value="1"> 女 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="安装类别" style="width: 320px">
                <a-select
                  mode="multiple"
                  v-decorator="['installType', { rules: [{ required: true, message: '请选择安装类别' }] }]"
                >
                  <a-select-option v-for="item in installTypeMap" :key="item.code">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="接单方式" style="width: 320px">
                <a-select
                  mode="multiple"
                  v-decorator="['receiptType', { rules: [{ required: true, message: '请选择分单方式' }] }]"
                  @change="handleChange"
                >
                  <a-select-option value="0"> 自动分单 </a-select-option>
                  <a-select-option value="1"> 手动分单 </a-select-option>
                  <a-select-option value="2"> 抢单 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="备用联系方式" style="width: 320px">
                <a-input
                  v-decorator="['contactReserve', { rules: [{ required: false, message: '请输入备用联系方式' }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="身份证号码" style="width: 320px">
                <a-input v-decorator="['idCard', { rules: [{ required: false, message: '请输入手机号' }] }]" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item label="详细地址" style="width: 688px">
                <a-row :gutter="24">
                  <a-col :span="5">
                    <a-form-item>
                      <a-select
                        :allowClear="true"
                        :options="provinceMap"
                        @change="changeProvince"
                        v-decorator="['provinceId', { rules: [{ required: true, message: '请选择省' }] }]"
                      ></a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5">
                    <a-form-item>
                      <a-select
                        :allowClear="true"
                        :options="cityMap"
                        @change="changeCity"
                        v-decorator="['cityId', { rules: [{ required: true, message: '请选择市' }] }]"
                      ></a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5">
                    <a-form-item>
                      <a-select
                        :allowClear="true"
                        :options="areaArr"
                        v-decorator="['districtId', { rules: [{ required: true, message: '请选择区' }] }]"
                      ></a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="9">
                    <a-form-item>
                      <a-input
                        :allowClear="true"
                        v-decorator="['detailedAddress', { rules: [{ required: true, message: '请输入详细地址' }] }]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="角色" style="width: 320px">
                <a-select
                  :allowClear="true"
                  :options="roleData3"
                  v-decorator="['roleIds', { rules: [{ required: true, message: '请选择角色' }] }]"
                ></a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="师傅负责人" style="width: 320px">
                <a-select v-decorator="['masterLeading', { rules: [{ required: true, message: '请选择师傅负责人' }] }]">
                  <a-select-option v-for="type in pullDown" :key="type.userId">{{ type.userName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="平台使用情况" style="width: 320px">
                <a-select
                  mode="multiple"
                  v-decorator="['platformType', { rules: [{ required: true, message: '请选择平台使用情况' }] }]"
                >
                  <a-select-option v-for="type in restaurantTypes6" :key="type.code">{{ type.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="审核状态" style="width: 320px">
                <a-select
                  v-decorator="['auditStatus', { rules: [{ required: true, message: '选择' }], initialValue: '1' }]"
                >
                  <a-select-option value="1"> 通过 </a-select-option>
                  <a-select-option value="2"> 不通过 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
    <masterlist-edit ref="Mastermodal" @ok="query()"></masterlist-edit>
    <edit-order-model v-if="$store.state.user_type == 1" ref="editorder" @moneyok="query()"></edit-order-model>
    <edit-order-model1 v-else ref="editorder" @moneyok="query()"></edit-order-model1>
  </div>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import pick from 'lodash.pick'
import moment from 'moment'
import { checkPermission } from '@/utils/permissions'
export default {
  name: 'Toexamine',
  components: {
    MasterlistEdit: () => import('@/views/master/modules/MasterlistEdit'),
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1')
  },
  data() {
    return {
      batchEnable: checkPermission('toDo:batch'), //批量处理
      exportEnable: checkPermission('toDo:export'), //导出
      dispatchEnable: checkPermission('toDo:dispatchPending'), //转派
      recodeEnable: checkPermission('toDo:recode'), //履历
      pullDown: '',

      form: this.$form.createForm(this),
      queryParam: {},
      visible: false,
      confirmLoading: false,
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'no',
          width: '70px',
          align: 'center'
        },
        {
          title: '操作',
          width: '80px',
          dataIndex: 'statusArea',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '审核类型',
          dataIndex: 'matterName',
          align: 'center'
        },
        {
          title: '审核状态',
          dataIndex: 'auditStatus',
          align: 'center'
        },
        {
          title: '申请内容',
          dataIndex: 'content',
          align: 'center'
        },
        {
          title: '申请人',
          dataIndex: 'createByName',
          align: 'center'
        },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center'
        },
        {
          title: '安装类别',
          dataIndex: 'installTypeName',
          align: 'center'
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeName',
          align: 'center'
        },
        {
          title: '师傅姓名',
          dataIndex: 'workName',
          align: 'center'
        },
        {
          title: '师傅联系方式',
          dataIndex: 'workPhone',
          align: 'center'
        },
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          align: 'center'
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipalName',
          align: 'center'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatusName',
          align: 'center'
        },
        {
          title: '订单子状态',
          dataIndex: 'orderSubStatusName',
          align: 'center',
          scopedSlots: { customRender: 'action2' }
        },
        {
          title: '市场负责人名称',
          dataIndex: 'marketPrincipalName',
          align: 'center'
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipalName',
          align: 'center'
        },
        // {
        //   title: '当前协助人',
        //   dataIndex: 'helperName',
        //   align:'center'
        // },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center'
        },
        {
          title: '客户电话',
          dataIndex: 'clientPhone',
          align: 'center'
        }
        // {
        //   title: '审核时间',
        //   dataIndex: 'auditTime',
        //   align:'center'
        // },
        // {
        //   title: '总处理时长',
        //   dataIndex: 'totalProcessingTimeInfo',
        //   align:'center'
        // },
      ],
      pagination: false,
      loading: false,
      complaintData: [],
      querytime: {},
      isMyOrder: false,
      resTypes: [],
      isMyCreate: '0',
      visible2: false,
      confirmLoading2: false,
      form2: this.$form.createForm(this),
      Roledata: [],
      auditId: '',
      total: 0,
      pageSize: 10,
      pageNum: 1,
      dataResume: [],
      //员工审核
      queryParam2: {},
      confirmLoading3: false,
      form3: this.$form.createForm(this),
      visible3: false,
      roleData: [],
      roleData2: [],
      roleData3: [],
      departmentData: [],
      auditStatus: '',
      userId: '',
      //企业审核
      queryParam4: {},
      visible4: false,
      installTypes: [],
      installTypeMap: [],
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      confirmLoading4: false,
      enterpriseId: '',
      enterpriseUserId: '',
      form4: this.$form.createForm(this),
      //师傅审核
      visible5: false,
      updateTime: '',
      restaurantTypes6: [],
      confirmLoading5: false,
      form5: this.$form.createForm(this),
      //省市区
      provinceMap: [],
      cityMap: [],
      areaArr: []
    }
  },
  methods: {
    moment,
    handleOk() {
      this.query()
    },
    handleClose1() {
      this.visible3 = false
      this.query()
    },
    handleClose2() {
      this.visible4 = false
      this.query()
    },
    handleClose3() {
      this.visible5 = false
      this.query()
    },
    //市
    changeProvince(e) {
      this.cityMap = []
      this.areaArr = []
      this.form5.setFieldsValue({
        cityId: '',
        districtId: ''
      })
      this.form3.setFieldsValue({
        cityId: '',
        districtId: ''
      })
      // 市
      this.province = { provinceCode: e }
      this.$axios({
        method: 'post',
        url: '/api/basicdata/city/selectCityName',
        data: this.province,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        if (res.data.code === 0) {
          console.log(res.data.rows, '市')
          res.data.rows.forEach(province => {
            this.cityMap.push({ value: province.cityCode, label: province.cityName })
          })
        }
      })
    },
    //区
    changeCity(e) {
      this.areaArr = []
      this.form5.setFieldsValue({
        districtId: ''
      })
      this.form3.setFieldsValue({
        districtId: ''
      })
      // 区
      this.city = { cityCode: e }
      this.$axios({
        method: 'post',
        url: '/api/basicdata/area/selectAreaName',
        data: this.city,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res.data.rows, '区')
        if (res.data.code === 0) {
          res.data.rows.forEach(province => {
            this.areaArr.push({ value: province.areaCode, label: province.areaName })
          })
        }
      })
      // getselectAreaName(this.city).then(res => {
      //   if (res.code === 0) {
      //     res.rows.forEach(area => {
      //       this.areaArr.push({ value: area.areaCode, label: area.areaName })
      //     })
      //   }
      // })
    },
    //查询参数
    Biography(values) {
      values.isMyCreate = this.isMyCreate
      values.pageSize = this.pageSize
      values.pageNum = this.pageNum
      values.createTimeStart = this.querytime.createTimeStart
      values.createTimeEnd = this.querytime.createTimeEnd

      values.auditEndTimeStart = this.querytime.auditEndTimeStart
      values.auditEndTimeEnd = this.querytime.auditEndTimeEnd

      values.totalProcessingTimeStart = this.querytime.textTime3
      values.totalProcessingTimeEnd = this.querytime.textTime4
      values.totalProcessingTimeType = this.querytime.selectTime2
      delete values.datatime1
      delete values.datatime2
      return values
    },
    //导出
    exporto() {
      this.form.validateFields((err, values) => {
        var str = process.env.VUE_APP_API_BASE_URL + '/backlog/audit/export?pageSize=10&pageNum=1'

        var arrStr = this.Biography(values)
        for (let i in arrStr) {
          if (arrStr[i] != undefined) {
            str = str + '&' + i + '=' + arrStr[i]
          }
        }
        str = str + '&token=' + this.headers.token
        window.open(str)
      })
    },
    //履历
    Resume(values) {
      this.$axios({
        method: 'get',
        url: '/api/backlog/pendingMatter/getPendingMattersResume',
        params: {
          pendingMattersRecordId: values.auditId,
          matterCode: values.matterCode
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        this.dataResume = res.data.data
      })
      // /pendingMatter/getPendingMattersResume
    },
    //分页
    onChangePage(pageNumber) {
      this.pageNum = pageNumber
      this.query()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.pageNum = current
      this.query()
    },
    //审核
    handles(value) {
      console.log(value)
      this.roleData3 = []
      this.roleData2 = []
      if (value.jumpUrl === 'ReviewedByMaster') {
        //师傅审核
        this.visible5 = true
        this.form5.resetFields()
        this.userId = value.masterId
        //获取师傅角色下拉数据
        this.$axios({
          method: 'get',
          url: '/api/system/role/masterRoleList',
          params: {},
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          if (res.data.code == 0) {
            res.data.rows.forEach(province => {
              this.roleData3.push({ value: province.roleId, label: province.roleName })
            })
          }
        })
        this.$axios({
          method: 'get',
          url: '/api/system/user/findByDeptId/106',
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          this.pullDown = res.data
        })
        this.$axios({
          method: 'get',
          url: `/api/master/master/get`,
          params: {
            userId: this.userId
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          if (res.data.code == 0) {
            let arr = []
            for (var i = 0; i < res.data.data.installType.length; i++) {
              arr.push(res.data.data.installType[i].installType)
            }
            this.updateTime = res.data.data.updateTime
            this.changeProvince(res.data.data.provinceId)
            this.changeCity(res.data.data.cityId)
            res.data.data.installType = arr
            this.form5.setFieldsValue(
              pick(
                res.data.data,
                'name',
                'sex',
                'installType',
                'receiptType',
                'contactReserve',
                'provinceId',
                'cityId',
                'districtId',
                'detailedAddress',
                'idCard',
                'registerRole',
                'platformType'
              )
            )
            this.form5.setFieldsValue({
              platformType: ['2']
            })
            this.query()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else if (value.jumpUrl === 'EnterpriseAudit') {
        //企业
        this.visible4 = true
        this.enterpriseId = value.enterpriseId
        this.form4.resetFields()

        //获取企业角色下拉数据
        this.$axios({
          method: 'get',
          url: '/api/system/role/enterpriseRoleAll',
          params: { enterpriseId: 1 },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          if (res.data.code == 0) {
            res.data.rows.forEach(province => {
              this.roleData2.push({ value: province.roleId, label: province.roleName })
            })
            this.form4.setFieldsValue({
              roleIds: 35
            })
          }
        })
        this.$axios({
          method: 'get',
          url: '/api/enterprise/management/get',
          params: {
            enterpriseId: this.enterpriseId
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.enterpriseUserId = res.data.data.enterpriseUserId
            this.form4.setFieldsValue(
              pick(
                res.data.data,
                'loginName',
                'userName',
                'enterpriseName',
                'enterpriseSysName',
                'register',
                'registerPhone',
                'phone',
                'installTypes',
                'defaultInstallType',
                'registerRole'
              )
            )
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else if (value.jumpUrl === 'EmployeeReview') {
        //员工
        this.visible3 = true
        this.userId = value.employeeId
        this.form3.resetFields()
        this.$axios({
          method: 'post',
          url: '/api/system/user/getEmployee',
          data: {
            userId: this.userId
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          if (res.status == 200) {
            this.changeProvince(res.data.provinceId)
            this.changeCity(res.data.cityId)
            if (res.data.entryTime == null) {
              this.form3.setFieldsValue({
                entryTime: null
              })
            } else {
              this.form3.setFieldsValue({
                entryTime: moment(res.data.entryTime, 'YYYY-MM-DD')
              })
            }

            this.form3.setFieldsValue(
              pick(
                res.data,
                'loginName',
                'userName',
                'phone',
                'contactReserve',
                'sex',
                'registerDept',
                'registerRole',
                'provinceId',
                'cityId',
                'districtId',
                'detailedAddress',
                'linkmanPhonenumber',
                'emergencyContact'
              )
            )
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else if (value.jumpUrl === 'orderPriceAudit') {
        //订单详情-金额信息审核页面
        // this.$router.push({path:'/order/orderList', query:{orderNo: value.orderNo}})
        // this.$emit('Ok')
        let that = this
        this.$nextTick(() => {
          this.$refs.editorder.showeditOrder(value.orderId, 2, 1, '', value.auditStatus, 0, 3)
        })
        setTimeout(function() {
          that.$refs.editorder.examine()
        }, 1000)
      } else if (value.jumpUrl === 'orderInfo') {
        //订单详情
        // this.$router.push({path:'/order/orderList', query:{orderNo: value.orderNo}})
        // this.$emit('Ok')
        this.$refs.editorder.showeditOrder(value.orderId, 1, 1, '', value.auditStatus, 0, 3)
      } else if (value.jumpUrl === 'masterInfo') {
        //师傅详情
        value.userId = value.masterId
        this.$refs.Mastermodal.edit(value, '1', 1, 0)
      }
    },
    //转派提交
    handleSubmit2(e) {
      e.preventDefault()
      this.form2.validateFields((err, values) => {
        this.$axios({
          method: 'post',
          url: '/api/backlog/audit/transfer',
          params: {
            auditId: this.auditId,
            roleCode: values.roleCode
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.$message.success('转派成功')
            this.visible2 = false
            this.query()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    //转派
    Transfer(value) {
      this.auditId = value.auditId
      this.visible2 = true
      this.form2.setFieldsValue({
        roleCode: ''
      })
      //获取转派角色列表
      this.$axios({
        method: 'get',
        url: '/api/backlog/pendingMatter/getPendingMattersRoleList',
        params: {
          type: ''
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        this.Roledata = res.data.data
        this.query()
      })
    },
    number3() {
      this.regular(this.querytime.textTime3)
    },
    number4() {
      this.regular(this.querytime.textTime4)
    },
    regular(value) {
      value = value.replace(/[^\.\d]/g, '')
      value = value.replace('.', '')
    },
    timeChange2(value) {
      console.log(value)
      this.querytime.selectTime2 = value
    },
    restdata() {
      this.isMyCreate = '0'
      this.form.resetFields()
      this.querytime = {}
      this.query()
    },
    //申请时间
    onChange1(date, dateString) {
      console.log(dateString[0], dateString[1])
      this.querytime.createTimeStart = dateString[0]
      this.querytime.createTimeEnd = dateString[1]
    },
    //审核时间
    onChange2(date, dateString) {
      this.querytime.auditEndTimeStart = dateString[0]
      this.querytime.auditEndTimeEnd = dateString[1]
    },

    // 刷新表格数据
    dataList(data) {
      this.$axios({
        method: 'get',
        url: '/api/backlog/audit/getAuditList',
        params: data,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        this.complaintData = res.data.rows
        this.total = res.data.total
        this.$emit('Ok')
      })
    },
    //查询
    async query() {
      this.form.validateFields((err, values) => {
        if (this.isMyCreate == 1) {
          this.columns = [
            {
              title: '序号',
              dataIndex: 'no',
              width: '70px',
              align: 'center'
            },
            {
              title: '审核类型',
              dataIndex: 'matterName',
              align: 'center'
            },
            {
              title: '审核状态',
              dataIndex: 'auditStatus',
              align: 'center'
            },
            {
              title: '申请内容',
              dataIndex: 'content',
              align: 'center'
            },
            {
              title: '申请人',
              dataIndex: 'createByName',
              align: 'center'
            },
            {
              title: '申请时间',
              dataIndex: 'createTime',
              align: 'center'
            },
            {
              title: '企业名称',
              dataIndex: 'enterpriseName',
              align: 'center'
            },
            {
              title: '安装类别',
              dataIndex: 'installTypeName',
              align: 'center'
            },
            {
              title: '订单类型',
              dataIndex: 'orderTypeName',
              align: 'center'
            },
            {
              title: '师傅姓名',
              dataIndex: 'workName',
              align: 'center'
            },
            {
              title: '师傅联系方式',
              dataIndex: 'workPhone',
              align: 'center'
            },
            {
              title: '订单编号',
              dataIndex: 'orderNo',
              align: 'center'
            },
            {
              title: '市场负责人',
              dataIndex: 'marketPrincipalName',
              align: 'center'
            },
            {
              title: '订单状态',
              dataIndex: 'orderStatusName',
              align: 'center'
            },
            {
              title: '订单子状态',
              dataIndex: 'orderSubStatusName',
              align: 'center',
              scopedSlots: { customRender: 'action2' }
            },
            {
              title: '市场负责人名称',
              dataIndex: 'marketPrincipalName',
              align: 'center'
            },
            {
              title: '订单负责人',
              dataIndex: 'orderPrincipalName',
              align: 'center'
            },
            // {
            //   title: '当前协助人',
            //   dataIndex: 'helperName',
            //   align:'center'
            // },
            {
              title: '客户姓名',
              dataIndex: 'clientName',
              align: 'center'
            },
            {
              title: '客户电话',
              dataIndex: 'clientPhone',
              align: 'center'
            }
            // {
            //   title: '审核时间',
            //   dataIndex: 'auditTime',
            //   align:'center'
            // },
            // {
            //   title: '总处理时长',
            //   dataIndex: 'totalProcessingTimeInfo',
            //   align:'center'
            // },
          ]
        } else {
          this.columns = [
            {
              title: '序号',
              dataIndex: 'no',
              width: '70px',
              align: 'center'
            },
            {
              title: '操作',
              width: '80px',
              dataIndex: 'statusArea',
              scopedSlots: { customRender: 'action' }
            },
            {
              title: '审核类型',
              dataIndex: 'matterName',
              align: 'center'
            },
            {
              title: '审核状态',
              dataIndex: 'auditStatus',
              align: 'center'
            },
            {
              title: '申请内容',
              dataIndex: 'content',
              align: 'center'
            },
            {
              title: '申请人',
              dataIndex: 'createByName',
              align: 'center'
            },
            {
              title: '申请时间',
              dataIndex: 'createTime',
              align: 'center'
            },
            {
              title: '企业名称',
              dataIndex: 'enterpriseName',
              align: 'center'
            },
            {
              title: '安装类别',
              dataIndex: 'installTypeName',
              align: 'center'
            },
            {
              title: '订单类型',
              dataIndex: 'orderTypeName',
              align: 'center'
            },
            {
              title: '师傅姓名',
              dataIndex: 'workName',
              align: 'center'
            },
            {
              title: '师傅联系方式',
              dataIndex: 'workPhone',
              align: 'center'
            },
            {
              title: '订单编号',
              dataIndex: 'orderNo',
              align: 'center'
            },
            {
              title: '市场负责人',
              dataIndex: 'marketPrincipalName',
              align: 'center'
            },
            {
              title: '订单状态',
              dataIndex: 'orderStatusName',
              align: 'center'
            },
            {
              title: '订单子状态',
              dataIndex: 'orderSubStatusName',
              align: 'center',
              scopedSlots: { customRender: 'action2' }
            },
            {
              title: '市场负责人名称',
              dataIndex: 'marketPrincipalName',
              align: 'center'
            },
            {
              title: '订单负责人',
              dataIndex: 'orderPrincipalName',
              align: 'center'
            },
            // {
            //   title: '当前协助人',
            //   dataIndex: 'helperName',
            //   align:'center'
            // },
            {
              title: '客户姓名',
              dataIndex: 'clientName',
              align: 'center'
            },
            {
              title: '客户电话',
              dataIndex: 'clientPhone',
              align: 'center'
            }
            // {
            //   title: '审核时间',
            //   dataIndex: 'auditTime',
            //   align:'center'
            // },
            // {
            //   title: '总处理时长',
            //   dataIndex: 'totalProcessingTimeInfo',
            //   align:'center'
            // },
          ]
        }
        this.dataList(this.Biography(values))
      })
    },
    handleSubmit3(e) {
      this.form3.validateFields((err, values) => {
        let arr = []
        if (!err) {
          this.confirmLoading3 = true
          arr.push(values.roleIds)
          values.roleIds = arr
          values.userId = this.userId
          this.$axios({
            method: 'post',
            url: '/api/system/user/auditEmployee',
            data: values,
            headers: {
              token: Vue.ls.get(ACCESS_TOKEN),
              'Content-Type': 'application/json;charset=UTF-8'
            }
          })
            .then(res => {
              if (res.data.code == 0) {
                this.confirmLoading3 = false
                this.$message.success('审核成功')
                this.visible3 = false
                this.query()
              } else {
                this.confirmLoading3 = false
                this.$message.error(res.data.msg)
              }
            })
            .catch(() => {
              0.0
              this.confirmLoading3 = false
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading3 = false
            })
        }
      })
    },
    handleSubmit4(e) {
      e.preventDefault()
      let arr = []
      this.form4.validateFields((err, values) => {
        arr.push(values.roleIds)
        values.roleIds = arr
        if (!err) {
          this.confirmLoading4 = true
          values.enterpriseUserId = this.enterpriseUserId
          values.enterpriseId = this.enterpriseId
          this.$axios({
            method: 'post',
            url: '/api/system/user/auditEnterprise',
            data: values,
            headers: {
              token: Vue.ls.get(ACCESS_TOKEN),
              'Content-Type': 'application/json;charset=UTF-8'
            }
          })
            .then(res => {
              console.log(res)
              if (res.data.code == 0) {
                this.confirmLoading4 = false
                this.$message.success('审核成功')
                this.visible4 = false
                this.query()
              } else {
                this.confirmLoading4 = false
                this.$message.error(res.data.msg)
              }
            })
            .catch(() => {
              this.confirmLoading4 = false
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading4 = false
            })
        }
      })
    },
    handleSubmit5(e) {
      e.preventDefault()
      this.form5.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading5 = true
          values.userId = this.userId
          values.updateTime = this.updateTime
          let obj = {}
          let arr = []
          for (var i = 0; i < values.installType.length; i++) {
            arr.push({
              code: values.installType[i]
            })
          }
          obj = {
            installType: arr
          }
          values.installType = obj
          this.$axios({
            method: 'post',
            url: '/api/master/master/auditMaster',
            data: values,
            headers: {
              token: Vue.ls.get(ACCESS_TOKEN),
              'Content-Type': 'application/json;charset=UTF-8'
            }
          })
            .then(res => {
              console.log(res)
              if (res.data.code == 0) {
                this.confirmLoading5 = false
                this.$message.success('审核成功')
                this.visible5 = false
                this.query()
              } else {
                this.confirmLoading5 = false
                this.$message.error(res.data.msg)
              }
            })
            .catch(() => {
              this.confirmLoading5 = false
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading5 = false
            })
        }
      })
    }
  },
  // mounted() {
  //   const s = document.createElement('script');
  //   s.type = 'text/javascript';
  //   s.src = '../permissions.js';
  //   document.body.appendChild(s);
  // },
  created() {
    //企业审核

    //获取平台使用情况下拉框
    this.$axios({
      method: 'get',
      // url: "/api/system/dict/data/list",
      url: '/api/system/dict/data/installList',
      params: {
        dictType: 'platform_type'
      },
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      console.log(res, '平台使用')
      if (res.data.code == 0) {
        res.data.rows.forEach((value, key) => {
          this.restaurantTypes6.push({ code: value.dictValue, label: value.dictLabel })
        })
      }
    })
    //获取部门下拉数据
    this.$axios({
      method: 'get',
      url: '/api/system/dept/list',
      params: {},
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      if (res.data.code == 0) {
        res.data.rows.forEach(province => {
          this.departmentData.push({ value: province.deptId, label: province.deptName })
        })
      }
    })

    //获取员工角色下拉数据
    this.$axios({
      method: 'get',
      url: '/api/system/role/all',
      params: {},
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      if (res.data.code == 0) {
        res.data.rows.forEach(province => {
          this.roleData.push({ value: province.roleId, label: province.roleName })
        })
      }
    })
    // 安装类型

    this.installTypeMap = []
    this.$axios({
      method: 'get',
      //url: "/api/system/dict/data/list",
      url: '/api/system/dict/data/installList',
      params: {
        dictType: 'install_type'
      },
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      res.data.rows.forEach((value, key) => {
        this.installTypeMap.push({ code: value.dictValue, name: value.dictLabel })
      })
    })

    // 省
    this.$axios({
      method: 'post',
      url: '/api/basicdata/province/selectAllProvince',
      data: {},
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      console.log(res, '省')
      if (res.data.code === 0) {
        res.data.rows.forEach(province => {
          this.provinceMap.push({ value: province.provinceCode, label: province.provinceName })
        })
      }
    })

    //获取审核类型下拉框
    this.$axios({
      method: 'get',
      url: '/api/backlog/pendingMatter/getPendingMatterMenu',
      params: {
        matterTypeCode: 'audit'
      },
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      this.resTypes = res.data.data
      //console.log(res.data.data,'获取投诉类型下拉框')
    })
  }
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px 16px;
}
</style>
